// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__ZdpiL","left":"StickyBox_left__t8uDB","right":"StickyBox_right__2gB2S"};